import { sectionalMargin, styled } from "@iventis/styles";
import React from "react";

export const FromGapComponent = () => <StyledFormGap role="presentation" />;

const StyledFormGap = styled.div`
    height: ${sectionalMargin};
`;
